export default {
  setEmojis(state, payload) {
    state.emojis = payload;
  },
  setEmojisIsEnabled(state, payload){
    state.emojisIsEnabled = payload;
  }
};
